<div class="hb-card">
  <div class="hb-felt hb-text--right hb-avstand--ingen">
    <input class="hb-checkbox" [id]="'checkbox-' + id()" type="checkbox" (click)="exportData()" />
    <div class="hb-label">
      <label class="hb-label-tekst hb-text--xs" [for]="'checkbox-' + id()" translate>Graf.Vis som tabell</label>
    </div>
  </div>

  <div [id]="idPrefix + id()" class="qlik" [style]="sizeStyle" [hidden]="visSomTabell" aria-hidden="true">
    <span class="hb-spinner hb-spinner--overliggende hb-spinner--tekst-justert" role="alert">
      <span class="hb-screenreader-only" translate>Graf.Vennligst vent, grafen laster</span>
    </span>
    <span class="hb-spinner-tekst" translate>Graf.Laster graf</span>
  </div>

  @if (visSomTabell) {
    <div [hidden]="!visSomTabell">
      <table class="hb-table-simple graf-tabell" summary="{{ hentFilterListe() }}">
        @if (qTable !== null) {
          <thead>
            <tr>
              @for (header of qTable.headers; track header; let i = $index) {
                <th [ngClass]="{ 'hb-text--right': i > 0 }">
                  {{ header.qFallbackTitle }}
                </th>
              }
            </tr>
          </thead>
        }
        <tbody>
          @for (element of getTable(); track element) {
            <tr>
              <td>{{ element[0].qText }}</td>
              <td class="hb-text--right">{{ element[1].qText }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <footer class="hb-card-footer hb-card-utfallende--bunn">
    <button hb-button variant="SUBTLE" iconId="hb-spreadsheet" title="Eksporter til excel" (click)="saveAsExcel()">Graf.Excel</button>
    <button
      hb-button
      variant="SUBTLE"
      [iconId]="visDatagrunnlagUtvidet ? 'remove' : 'book-open-text'"
      title="Vis datagrunnlag"
      (click)="visDatagrunnlagUtvidet = !visDatagrunnlagUtvidet"
    >
      Graf.Om grafen
    </button>
    @if (visDatagrunnlagUtvidet) {
      <div>
        <div class="hb-p--lg" id="info+id">
          <span class="hb-text--xs">{{ hentFilterListe() }}</span>
        </div>
      </div>
    }
  </footer>
</div>
